import React from 'react';

export default function TextStart() {
    return(
        <p className='txt-l space-25 mar-20'>gridea</p>
    );
}
